module.exports = __webpack_public_path__ + "media/images/clients/copy-d3ad04e3b69f1952aa45192779b2f08e.svg";